import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { QueryCommentModel } from 'src/app/core/models/QueryCommentModel';
import { QueryDeleteModel } from 'src/app/core/models/QueryDeleteModel';
import { QueryDetailModel } from 'src/app/core/models/QueryDetailModel';
import { QueryModel } from 'src/app/core/models/QueryModel';
import { BaseService } from 'src/app/core/services/base.service';

@Injectable({
  providedIn: 'root'
})
export class ClarificationQueryListService {
  private options = { headers: new HttpHeaders().set('Content-Type', 'application/json') };
  constructor(private baseService: BaseService) { }

  submitQuery(queryModel: QueryModel, fileToUpload: any) {
    const formData: FormData = new FormData();
    const reqHeader = new HttpHeaders({ 'Upload': 'True' });
    for (var i = 0; i < fileToUpload.length; i++) {
      formData.append('FileToUpload', fileToUpload[i], fileToUpload[i].name);
    }
    formData.append("query", JSON.stringify(queryModel));
    return this.baseService.post('ClarificationQuery/SubmitQuery', formData, { headers: reqHeader });
  }
  submitQueryByRFCAdmin(queryModel: QueryModel, fileToUpload: any) {
    const formData: FormData = new FormData();
    const reqHeader = new HttpHeaders({ 'Upload': 'True' });
    for (var i = 0; i < fileToUpload.length; i++) {
      formData.append('FileToUpload', fileToUpload[i], fileToUpload[i].name);
    }
    formData.append("query", JSON.stringify(queryModel));
    return this.baseService.post('ClarificationQuery/SubmitQueryByRFCAdmin', formData, { headers: reqHeader });
  }
  notifyToPartner(queryDetailModel: QueryDetailModel, fileToUpload: any) {
    const formData: FormData = new FormData();
    const reqHeader = new HttpHeaders({ 'Upload': 'True' });
    for (var i = 0; i < fileToUpload.length; i++) {
      formData.append('FileToUpload', fileToUpload[i], fileToUpload[i].name);
    }
    formData.append("queryDetail", JSON.stringify(queryDetailModel));
    return this.baseService.post('ClarificationQuery/NotifyToPartner', formData, { headers: reqHeader });
  }

  reopenQuery(queryDetailModel: QueryDetailModel, fileToUpload: any) {
    const formData: FormData = new FormData();
    const reqHeader = new HttpHeaders({ 'Upload': 'True' });
    for (var i = 0; i < fileToUpload.length; i++) {
      formData.append('FileToUpload', fileToUpload[i], fileToUpload[i].name);
    }
    formData.append("queryDetail", JSON.stringify(queryDetailModel));

    return this.baseService.post('ClarificationQuery/ReOpenQuery', formData, { headers: reqHeader });
  }

  sendResponseToPartner(queryCommentModel: QueryCommentModel, CCUsers: any, CCSubDepts: any, fileToUpload: any) {
    const formData: FormData = new FormData();
    const reqHeader = new HttpHeaders({ 'Upload': 'True' });
    for (var i = 0; i < fileToUpload.length; i++) {
      formData.append('FileToUpload', fileToUpload[i], fileToUpload[i].name);
    }
    formData.append("queryComment", JSON.stringify(queryCommentModel));
    formData.append("CCUsers", JSON.stringify(CCUsers));
    formData.append("CCSubDepts", JSON.stringify(CCSubDepts));
    return this.baseService.post('ClarificationQuery/SendResponseToPartner', formData, { headers: reqHeader });
  }

  sendRequestToDept(queryDetailModel: QueryDetailModel, fileToUpload: any) {
    const formData: FormData = new FormData();
    const reqHeader = new HttpHeaders({ 'Upload': 'True' });
    for (var i = 0; i < fileToUpload.length; i++) {
      formData.append('FileToUpload', fileToUpload[i], fileToUpload[i].name);
    }
    formData.append("queryDetail", JSON.stringify(queryDetailModel));
    return this.baseService.post('ClarificationQuery/SendRequestToDept', formData, { headers: reqHeader });
  }

  sendResponseToRFCAdmin(queryCommentModel: QueryCommentModel, fileToUpload: any) {
    const formData: FormData = new FormData();
    const reqHeader = new HttpHeaders({ 'Upload': 'True' });
    for (var i = 0; i < fileToUpload.length; i++) {
      formData.append('FileToUpload', fileToUpload[i], fileToUpload[i].name);
    }
    formData.append("queryComment", JSON.stringify(queryCommentModel));
    return this.baseService.post('ClarificationQuery/SendResponseToRFCAdmin', formData, { headers: reqHeader });
  }

  recycleQuery(queryDetailModel: QueryDetailModel, fileToUpload: any) {
    const formData: FormData = new FormData();
    const reqHeader = new HttpHeaders({ 'Upload': 'True' });
    for (var i = 0; i < fileToUpload.length; i++) {
      formData.append('FileToUpload', fileToUpload[i], fileToUpload[i].name);
    }
    formData.append("queryDetail", JSON.stringify(queryDetailModel));
    return this.baseService.post('ClarificationQuery/RecycleQuery', formData, { headers: reqHeader });
  }

  addAdditionalComment(queryCommentModel: QueryCommentModel, fileToUpload: any) {
    const formData: FormData = new FormData();
    const reqHeader = new HttpHeaders({ 'Upload': 'True' });
    for (var i = 0; i < fileToUpload.length; i++) {
      formData.append('FileToUpload', fileToUpload[i], fileToUpload[i].name);
    }
    formData.append("queryComment", JSON.stringify(queryCommentModel));
    return this.baseService.post('ClarificationQuery/AddAdditionalComment', formData, { headers: reqHeader });
  }

  deleteQuery(queryDeleteModel: QueryDeleteModel) {
    return this.baseService.post('ClarificationQuery/DeleteQuery', JSON.stringify(queryDeleteModel), this.options);
  }

  getQueryDetail(queryCode: number, userCode: number) {
    return this.baseService.get('ClarificationQuery/GetQueryDetail?queryCode=' + queryCode + '&userCode=' + userCode);
  }

  getQueryDetails(queryCode: number) {
    return this.baseService.get('ClarificationQuery/GetQueryDetails?queryCode=' + queryCode);
  }

  canViewQuery(queryCode: number, userCode: number) {
    return this.baseService.get('ClarificationQuery/CanViewQuery?queryCode=' + queryCode + '&userCode=' + userCode);
  }
  getAllQueries(userCode: number, queryRequertType: number, year: number) {
    return this.baseService.get('ClarificationQuery/GetAllQueries?userCode=' + userCode + '&queryRequertType=' + queryRequertType + '&year=' + year);
  }
  getRespondedQueries(userCode: number, year: number) {
    return this.baseService.get('ClarificationQuery/GetRespondedQueries?userCode=' + userCode + '&year=' + year);
  }

  getPendingQueries(userCode: number, year: number) {
    return this.baseService.get('ClarificationQuery/GetPendingQueries?userCode=' + userCode + '&year=' + year);
  }

  downloadFile(queryCode: number, queryDetailCode: number, filePath: string) {
    return this.baseService.get('ClarificationQuery/DownloadFile?queryCode=' + queryCode + '&queryDetailCode=' + queryDetailCode + '&filePath=' + filePath);
  }

  getAllAttachments(queryCode: number, queryDetailCode: number) {
    return this.baseService.get('ClarificationQuery/GetAllAttachments?queryCode=' + queryCode + '&queryDetailCode=' + queryDetailCode);
  }
}
